export enum COLOR_PALETTE {
	PURPLE_100 = "#E6E5EC",
	PURPLE_500 = "#3C2286",
	PURPLE_600 = "#371E78",
	DARK_PURPLE_600 = "#211D45",

	YELLOW_100 = "#FEF4E5",
	YELLOW_500 = "#FCC123",
	YELLOW_600 = "#E1AD1F",

	GRAY_160 = "#2E2F32",
	GREEN = "#2A8703",
	RED = "#DE1C24",

	CHART_1 = "#004F9A",
	CHART_2 = "#DB6BB1",
	CHART_3 = "#459FBC",
	CHART_4 = "#AF2F00",
	CHART_5 = "#A184B2",
	CHART_6 = "#3F931C",
	CHART_7 = "#CC851A",
	CHART_8 = "#A22373",
	CHART_9 = "#E15300",
	CHART_10 = "#FFC220",

	HEADER_2 = "#FAEAF4",
	HEADER_3 = "#EEF9FD",

	DISABLED_COLOR = "#d0d0d0",
}

export const WALMART_SANKEY_COLORS: string[] = [
	COLOR_PALETTE.CHART_1,
	COLOR_PALETTE.CHART_2,
	COLOR_PALETTE.CHART_3,
	COLOR_PALETTE.CHART_5,
	COLOR_PALETTE.CHART_7,
	COLOR_PALETTE.CHART_8,
	COLOR_PALETTE.CHART_9,
	COLOR_PALETTE.CHART_10,
]

export const CHART_COLORS: string[] = [
	COLOR_PALETTE.PURPLE_500,
	COLOR_PALETTE.CHART_2,
	COLOR_PALETTE.YELLOW_600,
	COLOR_PALETTE.CHART_3,
	COLOR_PALETTE.CHART_4,
	COLOR_PALETTE.CHART_5,
]
export const GENDER_COLORS: string[] = [
	COLOR_PALETTE.PURPLE_500,
	COLOR_PALETTE.CHART_2,
	COLOR_PALETTE.YELLOW_600,
]
export const WALMART_POSITIVE_COLORS: string[] = [COLOR_PALETTE.GREEN]
export const WALMART_NEGATIVE_COLORS: string[] = [COLOR_PALETTE.RED]
